import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CreateProjectComponent } from '../popup/create-project/create-project.component';
import { Project, ProjectUploadModel } from '../models/project';

@Injectable({
  providedIn: 'root'
})
export class CreateProjectService {

  constructor(private modalService : BsModalService) { }

  showModal(project: Project, editMode:boolean, existingProjectList: Project[]){
    const bsModalRef : BsModalRef = this.modalService.show(CreateProjectComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.project = project;
    bsModalRef.content.editMode = editMode;
    // New Project is the default create project name
    bsModalRef.content.nameExist = existingProjectList.findIndex(proj => proj.name == "New Project") != -1 && !editMode;
  }

  showImportModal(project: ProjectUploadModel, existingProjectList: Project[]){
    const bsModalRef : BsModalRef = this.modalService.show(CreateProjectComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.project = project;
    bsModalRef.content.editMode = false;
    // New Project is the default create project name
    bsModalRef.content.nameExist = existingProjectList.findIndex(proj => proj.name == "New Project") != -1;
  }



}
